import apiClient from "./api";
import { Opportunity, OpportunityListResponse } from "../types";
import { generateCacheKey, staleWhileRevalidate } from "../storage/cacheManager";
import {
  requestDeduplication,
  generateRequestKey,
} from "../utils/requestDeduplication";

class OpportunityService {
  private cacheExpiry: number = 30 * 60 * 1000; // 30 минут

  async getAllOpportunities(): Promise<OpportunityListResponse> {
    const attributeSelect = [
      "amountCurrency",
      "amount",
      "stage",
      "accountId",
      "accountName",
      "name",
    ];

    const queryParams = new URLSearchParams({
      orderBy: "createdAt",
      order: "desc",
      attributeSelect: attributeSelect.join(","),
    });

    const url = `/Opportunity?${queryParams.toString()}`;
    const cacheKey = "opportunities:list";
    const requestKey = generateRequestKey("GET", url, {
      orderBy: "createdAt",
      order: "desc",
      attributeSelect,
    });

    const fetchData = async (
      signal?: AbortSignal
    ): Promise<OpportunityListResponse> => {
      const response = await apiClient.get<OpportunityListResponse>(url, {
        signal,
      });
      return response.data;
    };

    const deduplicatedFetch = () =>
      requestDeduplication.execute(requestKey, fetchData);

    const result = await staleWhileRevalidate(
      cacheKey,
      deduplicatedFetch,
      this.cacheExpiry
    );

    return result;
  }
}

export const opportunityService = new OpportunityService();

export type { Opportunity, OpportunityListResponse };
export const getAllOpportunities = () =>
  opportunityService.getAllOpportunities();
